import { cloneDeep, sum } from 'lodash';
import { ITableLayer } from '@/version-types';

/** 检查表格数据是否符合规范 */
export const checkTableNumberIsValid = (layer: ITableLayer) => {
    const checkNumber = (num: number) => Number.isInteger(num) && num > 0;
    const { horizontal: hSizes, vertical: vSizes } = layer.data.baseCells;
    return (
        // hSizes.every(checkNumber) &&
        vSizes.every(checkNumber) && checkNumber(layer.width) && checkNumber(layer.height)
    );
};

/** 修复表格数据 */
export const getFixedTableNumber = (layer: ITableLayer): ITableLayer => {
    // hSizes先不要修复, 修复的话width偏差会很大, 暂时没想到好的解决方案
    const fixNumber = Math.ceil;

    const newLayer = cloneDeep(layer);

    newLayer.width = fixNumber(newLayer.width);

    const baseCells = newLayer.data.baseCells;
    // const oldHSizeAcc = sum(baseCells.horizontal);
    const oldVSizeAcc = sum(baseCells.vertical);
    // baseCells.horizontal = baseCells.horizontal.map(fixNumber);
    baseCells.vertical = baseCells.vertical.map(fixNumber);
    // const newHSizeAcc = sum(baseCells.horizontal);
    const newVSizeAcc = sum(baseCells.vertical);
    // const deltaOfWidth = newHSizeAcc - oldHSizeAcc;
    const deltaOfHeight = newVSizeAcc - oldVSizeAcc;
    // newLayer.width = fixNumber(newLayer.width + deltaOfWidth);
    newLayer.height = fixNumber(newLayer.height + deltaOfHeight);

    return newLayer;
};
